export * from './smile'



// WEBPACK FOOTER //
// ./src/app/front-face/shared/smile/index.ts